 import React, { useState } from "react";
import "../Style/productSection.css";

// Product Images
 
import dhoop1 from '../assets/image/product/dhoop1.webp'
import dhoop2 from '../assets/image/product/dhoop2.webp'
import dhoop3 from '../assets/image/product/dhoop3.webp'
import dhoop4 from '../assets/image/product/dhoop4.webp'
import dhoop5 from '../assets/image/product/dhoop5.webp'
import madhuban1 from '../assets/image/product/3.webp'
import madhuban2 from '../assets/image/product/md2.webp'
import madhuban3 from '../assets/image/product/md3.webp'
import kachha_bella1 from '../assets/image/product/1.webp'
import kachha_bella2 from '../assets/image/product/Kaccha Bella2.webp'
import kachha_bella3 from '../assets/image/product/Kaccha Bella3.webp'
import Shagun_Premium1 from '../assets/image/product/2.webp'
import Shagun_Premium2 from '../assets/image/product/Shagun_Premium2.webp'
import Shagun_Premium3 from '../assets/image/product/Shagun_Premium3.webp'

 

 // Product Data
const products = [




  {
    id: 1,
    category: "Dhoopbatti",
      title: (
    <>
      LUXE Premium <br /> Dhoop
    </>
  ),
    desc: "Calming fragrance to relax your mind and soul.",
    rate: "₹150 / 10 pcs",
    weight: "",   // 👈 added
    images: [dhoop1, dhoop2, dhoop3, dhoop4, dhoop5],
  },
  {
    id: 2,
    category: "Agarbatti",
    title: "Madhuban Premium Agarbatti",
    desc: "Pure natural incense sticks for home & temple.",
    rate: "₹65 / pack",
    weight: "140 gm",   // 👈 added
    images: [madhuban1, madhuban2, madhuban3],
  },
   
  {
    id: 3,
    category: "Agarbatti",
    title: "Kachha Bella Premium Agarbatti",
    desc: "Refreshing aroma for your meditation.",
    rate: "₹65 / pack",
    weight: "140 gm",   // 👈 added
    images: [kachha_bella1, kachha_bella2, kachha_bella3],
  },
  {
    id: 4,
    category: "Agarbatti",
    title: "Shagun Premium Agarbatti",
    desc: "Relaxing incense for home & temple.",
    rate: "₹70 / pack",
    weight: "200 gm",   // 👈 added
    images: [Shagun_Premium1, Shagun_Premium2, Shagun_Premium3],
  },
];


const categories = ["All", "Agarbatti", "Dhoopbatti"];

const ProductSection = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [mainImageIndex, setMainImageIndex] = useState({});
  const [visibleCount, setVisibleCount] = useState(4);

  const filteredProducts = selectedCategory === "All"
    ? products
    : products.filter((p) => p.category === selectedCategory);

  const handleThumbnailClick = (productId, idx) => {
    setMainImageIndex({ ...mainImageIndex, [productId]: idx });
  };

  const loadMore = () => {
    setVisibleCount(prev => prev + 4);
  };

  return (
    <section className="product-section">
      <h2 className="section-title">Our Products</h2>

      {/* Category Filter */}
      <div className="category-filter">
        {categories.map(cat => (
          <button
            key={cat}
            className={`category-btn ${selectedCategory === cat ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Product Grid */}
      <div className="product-grid">
        {filteredProducts.slice(0, visibleCount).map(product => {
          const mainIdx = mainImageIndex[product.id] || 0;
          return (
            <div key={product.id} className="product-card">
              <div className="main-image-container">
                <img
                  src={product.images[mainIdx]}
                  alt={product.title}
                  className="main-image"
                />
              </div>

              <div className="thumbnail-row">
                {product.images.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    alt={`${product.title} ${idx + 1}`}
                    className={`thumbnail ${mainIdx === idx ? "active-thumb" : ""}`}
                    onClick={() => handleThumbnailClick(product.id, idx)}
                  />
                ))}
              </div>

              <div className="product-info">
                <span className="product-category">{product.category}</span>
                <h3 className="product-title">{product.title}</h3>
                <p className="product-desc">{product.desc}</p>
                <p className="product-rate">{product.rate}</p>
                <p className="product-weight">{product.weight}</p>

                <a
                  href="https://wa.me/919907705500"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn"
                >
                  Contact on WhatsApp
                </a>
              </div>
            </div>
          );
        })}
      </div>

      {/* Load More Button */}
      {visibleCount < filteredProducts.length && (
        <button className="load-more-btn" onClick={loadMore}>
          Load More
        </button>
      )}
    </section>
  );
};

export default ProductSection;
